export const showAlert = (message: string) => {
  return alert(message);
};
